module.exports = {
      id: "newsletterimg-usage",
      viewBox: "0 0 125 112",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#newsletterimg",
      toString: function () {
        return this.url;
      }
    }